/**
 * Container for a ScreenWeb component.
 */
import React from 'react'
import { connect } from 'react-redux'
import { Dispatch, AnyAction } from 'redux'

import { RootStoreState } from '../../root/index'
import { Screen } from '../../api/types'
import * as actions from '../actions'
import { toggleBadgeModal } from '../../badges/actions'
import { getCurrentLanguageCode } from '../../settings/functions'
import { generateScreenVersion } from '../functions'

export interface OwnProps {
	itemId: number
	itemVersion?: number
	accountId?: number
	isPageContent?: boolean
	onBackAction?: (params: any) => void
}

export interface Props extends OwnProps {
	screen?: Screen
	loading?: boolean
	error?: Error
	language: string
}

export interface Actions {
	loadItem: (id: number, version: number, language: string, accountId?: number) => void
	clearError: (itemId: number) => void
	toggleBadgeModal: (show: boolean, badgeId: number, shouldBePushedToEarned: boolean, earned: boolean) => void
}

const mapStateToProps = (state: RootStoreState, ownProps: OwnProps): Props => {
	const { itemId, itemVersion } = ownProps
	const screen = state.screen.screens.get(itemId)

	const language: string = getCurrentLanguageCode(state)

	const manifestScreenVersion = state.settings.appManifest?.screens?.find(item => item.id === itemId)?.version

	return {
		...ownProps,
		itemVersion: itemVersion || manifestScreenVersion || generateScreenVersion(),
		screen: screen && screen.screen && screen.version === ownProps.itemVersion ? screen.screen : undefined,
		loading: screen ? screen.loading : false,
		error: screen ? screen.error : undefined,
		language,
	}
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): Actions => ({
	loadItem: (id: number, version: number, language: string, accountId?: number) => {
		dispatch(actions.loadScreen({ id, version, language, accountId }))
	},
	clearError: (id: number) => {
		dispatch(actions.clearLoadScreenErrorAction(id))
	},
	toggleBadgeModal: (show: boolean, badgeId: number, shouldBePushedToEarned: boolean, earned: boolean) => {
		dispatch(toggleBadgeModal({ show, badgeId, earned, shouldBePushedToEarned }))
	},
})

export default (Component: React.ComponentType<Props & Actions>) =>
	connect(mapStateToProps, mapDispatchToProps)(Component)
